// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupContentDefault_wrapper__2zd_H"};